"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerseveranceLanding = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const TileType_1 = require("../../TileType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const NaturalPreserve_1 = require("../base/NaturalPreserve");
class PerseveranceLanding extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PERSEVERANCE_LANDING,
            tags: [Tags_1.Tags.SPACE],
            cost: 1,
            metadata: {
                cardNumber: 'Z01',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tile(TileType_1.TileType.PERSEVERANCE_LANDING, true).br;
                }),
                description: 'Place this tile NEXT TO NO OTHER TILE.',
            },
        });
    }
    canPlay(player) {
        return NaturalPreserve_1.NaturalPreserve.getAvailableSpaces(player).length > 0;
    }
    play(player) {
        return new SelectSpace_1.SelectSpace('Select space for special tile', NaturalPreserve_1.NaturalPreserve.getAvailableSpaces(player), TileType_1.TileType.PERSEVERANCE_LANDING, (foundSpace) => {
            player.game.addTile(player, foundSpace.spaceType, foundSpace, { tileType: TileType_1.TileType.PERSEVERANCE_LANDING });
            return undefined;
        });
    }
}
exports.PerseveranceLanding = PerseveranceLanding;
//# sourceMappingURL=PerseveranceLanding.js.map